async function encryptData(data, password) {
  const salt = window.crypto.getRandomValues(new Uint8Array(16));
  const iv = window.crypto.getRandomValues(new Uint8Array(16));
  const keyMaterial = await window.crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(password),
    "PBKDF2",
    false,
    ["deriveKey"]
  );

  const key = await window.crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: salt,
      iterations: 100000,
      hash: "SHA-256"
    },
    keyMaterial,
    { name: "AES-CBC", length: 256 },
    false,
    ["encrypt"]
  );

  const encryptedData = await window.crypto.subtle.encrypt(
    { name: "AES-CBC", iv: iv },
    key,
    data
  );

  return { encryptedData, iv, salt };
}

async function decryptData(encryptedData, iv, password) {
  const salt = window.crypto.getRandomValues(new Uint8Array(16)); // 같은 salt 사용 필요
  const keyMaterial = await window.crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(password),
    "PBKDF2",
    false,
    ["deriveKey"]
  );

  const key = await window.crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: salt,
      iterations: 100000,
      hash: "SHA-256"
    },
    keyMaterial,
    { name: "AES-CBC", length: 256 },
    false,
    ["decrypt"]
  );

  const decryptedData = await window.crypto.subtle.decrypt(
    { name: "AES-CBC", iv: new Uint8Array(iv) },
    key,
    encryptedData
  );

  return new TextDecoder().decode(decryptedData);
}

export const testTest = () => {
  const fileInput = document.getElementById('fileInput');
  const file = fileInput.files[0];
  const password = '12341234'; // 예시 비밀번호, 실제 사용 시 안전한 방법 필요

  if (file) {
    const reader = new FileReader();
    reader.onload = async function(e) {
      const arrayBuffer = e.target.result;
      try {
        const { encryptedData, iv } = await encryptData(arrayBuffer, password);
        console.log('Encrypted:', encryptedData);

        const decryptedText = await decryptData(encryptedData, iv, password);
        console.log('Decrypted Text:', decryptedText);
      } catch (err) {
        console.error('Error:', err);
      }
    };
    reader.readAsArrayBuffer(file);
  }
}